import {
    NOTIFICATION_LIST_SUCCESS,
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_FAIL,
    // 
    NOTIFICATION_MARK_READ_REQUEST,
    NOTIFICATION_MARK_READ_SUCCESS,
    NOTIFICATION_MARK_READ_FAIL,
// 
    NOTIFICATION_MARK_ALL_READ_REQUEST,
    NOTIFICATION_MARK_ALL_READ_SUCCESS,
    NOTIFICATION_MARK_ALL_READ_FAIL,
// 
    NOTIFICATION_UNREAD_LIST_SUCCESS,
    NOTIFICATION_UNREAD_LIST_REQUEST,
    NOTIFICATION_UNREAD_LIST_FAIL,
    
    //
  } from "../constants/notificationConstants";


  export const getListUnreadNotificationsReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
      case NOTIFICATION_UNREAD_LIST_REQUEST:
        return { loadingListUnreadNotification: true, notifications: [] };
      case NOTIFICATION_UNREAD_LIST_SUCCESS:
        return {
          loadingListUnreadNotification: false,
          notifications: action.payload.notifications,
          pages: action.payload.pages,
          page: action.payload.page,
        };
      case NOTIFICATION_UNREAD_LIST_FAIL:
        return {
          loadingListUnreadNotification: false,
          errorListUnreadNotification: action.payload,
        };
      default:
        return state;
    }
  };


  export const getListNotificationsReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
      case NOTIFICATION_LIST_REQUEST:
        return { loadingListNotification: true, notifications: [] };
      case NOTIFICATION_LIST_SUCCESS:
        return {
          loadingListNotification: false,
          notifications: action.payload.notifications,
          pages: action.payload.pages,
          page: action.payload.page,
        };
      case NOTIFICATION_LIST_FAIL:
        return {
          loadingListNotification: false,
          errorListNotification: action.payload,
        };
      default:
        return state;
    }
  };

  export const markNotificationAsReadReducer = (state = {}, action) => {
    switch (action.type) {
      case NOTIFICATION_MARK_READ_REQUEST:
        return { loadingMarkRead: true };
      case NOTIFICATION_MARK_READ_SUCCESS:
        return {
          loadingMarkRead: false,
          successMarkRead: true,
          notificationMarked: action.payload,
        };
      case NOTIFICATION_MARK_READ_FAIL:
        return {
          loadingMarkRead: false,
          errorMarkRead: action.payload,
        };
      default:
        return state;
    }
  };

  export const markAllNotificationsAsReadReducer = (state = {}, action) => {
    switch (action.type) {
      case NOTIFICATION_MARK_ALL_READ_REQUEST:
        return { loadingMarkAllRead: true };
      case NOTIFICATION_MARK_ALL_READ_SUCCESS:
        return {
          loadingMarkAllRead: false,
          successMarkAllRead: true,
          result: action.payload,
        };
      case NOTIFICATION_MARK_ALL_READ_FAIL:
        return {
          loadingMarkAllRead: false,
          errorMarkAllRead: action.payload,
        };
      default:
        return state;
    }
  };